module.exports = __webpack_public_path__ + "img/mediate.fc2dfb32.png";